import { Button, Text } from "@fluentui/react-components";
import { DocumentRegular, InfoRegular } from "@fluentui/react-icons";
import { useAtomValue } from "jotai";
import { fileExtensionIcons } from "library/shared";
import { formatDateString, getExtensionFromUrl, openLinkInNewTab } from "library/utils";
import { useTranslation } from "react-i18next";
import { selectedClientAtom } from "store";
import styled from "styled-components";

export function EmployerDocuments() {
  const { t } = useTranslation();
  const selectedClient = useAtomValue(selectedClientAtom);

  const clientDocuments = selectedClient?.attachments || [];

  if (!clientDocuments?.length) {
    return (
      <NoDocumentsWrap>
        <InfoRegular fontSize={18} />
        <Text>{t("hbh.noDocuments.label")}</Text>
      </NoDocumentsWrap>
    );
  }
  return (
    <div>
      <Row>
        <Text weight="semibold">{t("hbh.name.label")}</Text>
        <Text weight="semibold">{t("hbh.uploaded.label")}</Text>
      </Row>
      {clientDocuments?.map((doc) => {
        const docType = getExtensionFromUrl(doc.attachmentPath);

        return (
          <Row key={doc.attachmentName}>
            <DocItemButton
              key={doc.attachmentName}
              onClick={() => {
                openLinkInNewTab(doc.attachmentPath || "");
              }}
              icon={fileExtensionIcons[docType] || <DocumentRegular />}
              appearance="subtle"
              style={{
                paddingLeft: 0,
                justifyContent: "flex-start",
              }}
            >
              <Text key={doc.attachmentName}>{doc.attachmentName}</Text>
            </DocItemButton>
            <Text>{formatDateString(doc?.lastModifiedAt || "")}</Text>
          </Row>
        );
      })}
    </div>
  );
}
const Row = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  max-width: 700px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutralLight};
  padding: 10px;
  align-items: center;
`;

const DocItemButton = styled(Button)`
  display: flex;
  text-align: left;
  text-decoration: underline;
  width: 100%;
`;

const NoDocumentsWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 40px;
  padding-left: 10px;
`;
